import React from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
    Card,
    CardContent,
    Grid,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from "@material-ui/core";
import TableWrap from "../../../components/TableWrap/TableWrap";
import * as AccActions from "../../../actions/account";
import { useActions } from "../../../actions";
import Pagination from "../../../components/table/Pagination";
import { dateUtils } from "../../../utils";
import { Link } from "react-router-dom";

type StatusType = 0 | 1;

interface AAI {
    agentId: number | undefined;
}

interface Header {
    AI: string
    CN: string
    DT: DT
}

type DT = string

interface PanelProps {
    agentId: number;
    status: StatusType;
    title: string;
    header: Header;
}

const header:Header = {
    AI: "Action Item",
    CN: "Client Name",
    DT: "Date Added"
}

const ActionItemsPanel: React.FC<PanelProps> = ({ agentId, status, title, header }) => {
    const accActions = useActions(AccActions);

    const [data, setData] = React.useState<any[]>([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const [totalCount, setTotalCount] = React.useState(0);
    const [expanded, setExpanded] = React.useState(false);

    const loadData = async (agentId:number, status:number) => {
        let queryObj: any = {
            page,
            rowsPerPage,
            status
        };
        try {
            const res: any = await accActions.getAgentActionItems(agentId, queryObj);
            setData(res && res.rows || []);
            setTotalCount(res && res.count || 0);
        } catch (err) {
            console.error(err);
        }
    };

    React.useEffect(() => {
        if (!agentId) return;
        if (expanded) {
            loadData(agentId, status).then();
        }
    }, [agentId, status, expanded, page, rowsPerPage]);

    function getFullName(item: any): string {
        if (item && item.client && item.client.user) {
            const { firstName, lastName } = item.client.user;
            return ((!!firstName ? firstName:'') + ' ' + (!!lastName ? lastName:'')).trim();
        }
        return '';
    }

    function getClientDetailLink(item: any): string {
        const clientId = item && item.client && item.client.id || "";
        const clientPolicy = item && item.client && item.client.clientPolicies && item.client.clientPolicies.length > 0 && item.client.clientPolicies[0];

        const policyId = clientPolicy.id || "";
        return `/new-client/detail/${clientId}/${policyId}`;
    }

    return (
            <ExpansionPanel
                    expanded={expanded}
                    onChange={(_, isExpanded) => {
                        setExpanded(isExpanded);
                    }}
            >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className="pd16Small">
                    <Typography variant="body1" className="mb0">{title}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className="accordionContent w100">
                    <Grid item xs={12}>
                        <Card className="muiCard mt0">
                            <CardContent className="muiCardContent">
                                <Grid item xs={12}>
                                    <TableWrap>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell padding="default">{header.AI}</TableCell>
                                                <TableCell padding="default">{header.DT}</TableCell>
                                                <TableCell padding="default">{header.CN}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.length > 0 ? (
                                                    data.map((item, idx) => (
                                                            <TableRow key={idx}>
                                                                <TableCell>{item.actionRequired}</TableCell>
                                                                <TableCell>{dateUtils.asDbDateFormat(item.createdAt)}</TableCell>
                                                                <TableCell><Link to={getClientDetailLink(item)}>{getFullName(item)}</Link></TableCell>
                                                            </TableRow>
                                                    ))
                                            ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={3} align="center">
                                                            No Data Found
                                                        </TableCell>
                                                    </TableRow>
                                            )}
                                        </TableBody>
                                    </TableWrap>
                                    <Pagination
                                            page={Number(page)}
                                            rowsPerPage={Number(rowsPerPage)}
                                            setPage={setPage}
                                            setRowsPerPage={setRowsPerPage}
                                            accountList={{ count: totalCount || 0 }}
                                    />
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </ExpansionPanelDetails>
            </ExpansionPanel>
    );
};

function AgentActionItems(props: AAI) {
    const { agentId } = props;

    if (!agentId) return null;

    return (
            <React.Fragment>
                <ActionItemsPanel agentId={agentId} status={0} title="Current Action Items" header={{ ...header, DT: "Date Added"}} />
                <br/>
                <ActionItemsPanel agentId={agentId} status={1} title="Completed Action Items" header={{ ...header, DT: "Date Completed" }} />
            </React.Fragment>
    );
}

export default AgentActionItems;
